import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import makerjs from "makerjs";
export class Polygon extends AbstractShape {
	constructor( dimensions?: object, modifiers?: object ) {
		super( 'polygon', dimensions, modifiers );
	}

	getLength(): Length {
		return this.cleanedPrimitives.width;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getHeight(): Length {
		const measure = makerjs.measure.modelExtents(this.model);
		return Length.from_cm(measure.height);
	}

	getSideAmount(): number {
		return +this.cleanedPrimitives.side_amount;
	}

	getSideLength(): Length {
		const sideLength = 2 * this.getWidth().divide(2).in_mm() * Math.sin(Math.PI / this.getSideAmount());

		return Length.from_mm(sideLength);
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'width' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if (!this.model) {
			return [];
		}

		if(focusedElement.includes("cutout_measurement") || forceRender) {

			// @ts-expect-error - makerjs types are incorrect
			const line = this.getClosestLineToOrigin(this.model.paths);

			const startLine = [Length.from_cm(line.origin[0]).in_mm(), Length.from_cm(line.origin[1]).in_mm()];
			const endLine = [Length.from_cm(line.end[0]).in_mm(), Length.from_cm(line.end[1]).in_mm()];

			return [
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-polygon-width', focusedElement, forceRender) ),
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height', this.getHeight().in_cm() ), [-40, 0], ratio ),

				new DimensionLine( startLine, endLine, this.renderDimensionLabel( 'width', this.getSideLength().in_cm() ), [0, 0], ratio ),
			];
		}

		return [];
	}

	/**
	 * Creates a model instance of the shape.
	 */
	createModel(): void {
		if ( ! this.cleanedPrimitives.width || ! this.cleanedPrimitives.side_amount ) {
			return;
		}

		super.createModel();

		if ( ! this.model ) {
			return;
		}

		makerjs.model.zero( this.model );
		makerjs.model.originate( this.model );
	}

	getDefaultDimensions(): Dimensions {
		return {
			width: 80,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			width: width.divide(2).in_cm(),
		};
	}

	getDefaultCutoutModifiers(): object {
		return {
			side_amount: 8,
		};
	}

	getClosestLineToOrigin(shapeLines: makerjs.paths.Line[]): makerjs.paths.Line {
		let closestLine = '';
		let minDistance = Infinity;

		for (const [key, line] of Object.entries(shapeLines)) {
			const originDistance = Math.sqrt(Math.pow(line.origin[0], 2) + Math.pow(line.origin[1], 2));
			const endDistance = Math.sqrt(Math.pow(line.end[0], 2) + Math.pow(line.end[1], 2));

			const distance = Math.min(originDistance, endDistance);

			if (distance < minDistance) {
				minDistance = distance;
				closestLine = key;
			}
		}

		return shapeLines[closestLine];
	}
}
